//@ts-check

import React, { useState } from "react"
import { ReactSortable } from "react-sortablejs"

import StepCollapsed from "./step-collapsed"
import store from "../store"
import { StepIndexProvider, useStepIndex } from "./step-index-context"
/**
 * @param object {Object}
 * @param [object.abi] {import("../../../backend/interfaces").ABIField[]}
 */
export default function StepsList({ abi }) {
  store.useRerenderIfChange(() => [store.steps.length])
  var isOneSide = store.getView() == "oneside"
  function onChooseStep(newNumber) {
    if (isOneSide) {
      store.steps[newNumber].collapsed = !store.steps[newNumber].collapsed
    } else {
      store.selectedStep = newNumber
    }
    store.updateStore()
  }
  function onChange(newSteps) {
    store.steps = newSteps
    //store.updateSimulationMetadataProperty('numOfSteps', newSteps.length, store.currentStoryId);
    store.updateStore()
  }
  function onDelete(i) {
    var newSteps = store.steps.concat()
    var removedStepFuncName = store.steps[i].function_name
    store.updateStepFunctionsInUse(
      removedStepFuncName,
      store.currentStoryId,
      true,
    )
    newSteps.splice(i, 1)
    onChange(newSteps)
    if (isOneSide) {
      // do not collapse and decollapse
      return
    }
    if (i != 0) {
      onChooseStep(i - 1)
    } else {
      if (newSteps.length > 0) onChooseStep(0)
    }
  }
  function onDuplicate(i) {
    var newSteps = store.steps.concat()
    var newStep = JSON.parse(JSON.stringify(newSteps[i]))
    newStep.uid = new Date().valueOf()
    newSteps.splice(i, 0, newStep) // append to the array a clones version of this sterp
    onChange(newSteps)
    setTimeout(() => {
      store.selectedStep = i + 1
      store.updateStore()
    }, 0)
  }
  function changeStep(index, newStep) {
    var newSteps = store.steps.concat()
    newSteps[index] = newStep
    onChange(newSteps)
  }

  const moveStep = (stepIndex, direction) => {
    if (direction === 'up') {
        if (stepIndex <= 0) {
            console.log('Cannot move up, already at the top.');
            return;
        }

        const temp = store.steps[stepIndex];
        store.steps[stepIndex] = store.steps[stepIndex - 1];
        store.steps[stepIndex - 1] = temp;
        store.updateStore()
    } else if (direction === 'down') {
        if (stepIndex >= store.steps.length - 1) {
            console.log('Cannot move down, already at the bottom.');
            return;
        }

        const temp = store.steps[stepIndex];
        store.steps[stepIndex] = store.steps[stepIndex + 1];
        store.steps[stepIndex + 1] = temp;
        store.updateStore()
    } else {
        console.log('Invalid direction. Use "up" or "down".');
    }
}

const onAddStep = (stepIndex) => {
  console.log("stepIndex", stepIndex);
}

  var [isStartMoving, setIsStartMoving] = useState(false)
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow-y: auto;
        border-left: 1px solid #eee;
        padding-top: 12px;
      `}
    >
      <div
        css={`
          [draggable="true"] .step-splitter {
            visibility: hidden;
          }
        `}
        style={{
          marginBottom: 8,
        }}
      >
        <ReactSortable
          list={store.steps}
          handle=".handle"
          onStart={() => {
            setIsStartMoving(true)
          }}
          onEnd={(evt, s1, s2) => {
            store.selectedStep = evt.newIndex
            setIsStartMoving(false)
            store.results = []
            store.updateStore()
          }}
          setList={(newList) => {
            function isValidList(steps) {
              for (var i = 0; i < steps.length - 1; i++) {
                var currentIsDefault = steps[i].defaultStep
                var nextIsDefault = steps[i + 1].defaultStep
                console.log({ i, currentIsDefault, nextIsDefault })
                if (!currentIsDefault && nextIsDefault) {
                  return false
                }
              }
              return true
            }

            if (!isValidList(newList)) return
            store.steps = newList
            store.updateStore()
            store.saveStory()
          }}
        >
          {store.steps?.map((step, index) => {
            return (
              <StepIndexProvider value={index} key={index}>
                <StepCollapsed
                  key={index}
                  isSelected={index === store.selectedStep}
                  //@ts-ignore
                  onClick={() => onChooseStep(index)}
                  abi={abi}
                  onChange={changeStep.bind(null, index)}
                  onDelete={onDelete.bind(null, index)}
                  onDuplicate={(e) => {
                    e.preventDefault()
                    onDuplicate(index)
                    return false
                  }}
                  showLines={!isStartMoving}
                  onMoveStep={(stepIndex, direction) => {
                    moveStep(stepIndex, direction)
                  }}
                  onAddStep={(stepIndex) => onAddStep(stepIndex)}
                />
              </StepIndexProvider>
            )
          })}
        </ReactSortable>
      </div>
    </div>
  )
}
